var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "link",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7250",
    "data-name": "Rectangle 7250",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M13.061,8.111l1.414,1.414a7,7,0,0,1,0,9.9l-.354.354a7,7,0,1,1-9.9-9.9l1.414,1.414a5,5,0,0,0,7.071,7.071l.354-.354a5,5,0,0,0,0-7.071L11.646,9.525Zm6.717,6.01-1.414-1.414a5,5,0,1,0-7.071-7.071l-.353.354a5,5,0,0,0,0,7.071l1.414,1.414-1.414,1.414L9.525,14.475a7,7,0,0,1,0-9.9l.354-.354a7,7,0,0,1,9.9,9.9Z",
    transform: "translate(0.829 -0.172)",
    fill: "#1dbbbe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.2b4f9df9c31d58ae6a7c61e610632165.svg";
export { ForwardRef as ReactComponent };